import { toast } from 'react-toastify';
import { ERROR_MESSAGES } from '@/shared/constants/error-messages';
import { IErrorResponse } from '../types/interfaces';

export const unfulfilledGenerateVerificationCodeAlertHandler = (payload: IErrorResponse) => {
    let message = payload?.message || '';
    if (payload && payload.code >= '500') message = ERROR_MESSAGES.SERVER_ERROR;
    toast.error(message);
};
